import React from "react";
import classNames from "classnames/bind";

import placeholderImage from "./assets/placeholder.svg";

import { DietanamnezTileForm } from "../../components/DietanamnezTileForm";

import { Tile } from "../../types/Tile";
import { DietanamnezItemForm } from "../../types/DietanamnezItem";

import styles from "./DietanamnezTile.module.css";

const cx = classNames.bind(styles);

type Props = {
  tile: Tile;
  initialValues?: DietanamnezItemForm;
  onSubmit: React.ComponentProps<typeof DietanamnezTileForm>["onSubmit"];
  portions: number[];
  tutorialWasShown: boolean;
  errorMessage?: { name: string, message: string };
  setErrorMessage?: any;
};

export const DietanamnezTile: React.FC<Props> = ({
  tile,
  initialValues,
  onSubmit,
  portions,
  tutorialWasShown,
  errorMessage,
  setErrorMessage,
}) => {
  return (
    <article className={cx("container")}>
      {errorMessage?.name && (
        <div className={cx("notification")} onClick={() => setErrorMessage({ name: "", message: "" })}>
          <span>{errorMessage?.message}</span>
          {/* <span className={cx("notification-close")}
            style={{ width: 12, height: 12 }}
            onClick={() => setErrorMessage({ name: "", message: "" })}
          >
            <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path
              d="M6.3 5l3.3-3.3c.3-.4.3-1 0-1.4C9.4 0 9 0 9 0c-.4 0-.7 0-.8.3L5 3.6 1.6.3C1.5 0 1.2 0 1 0 .7 0 .5 0 .3.3c-.4.4-.4 1 0 1.4L3.5 5 .3 8.2c-.4.4-.4 1 0 1.4.2.2.4.3.7.3l.7-.4L5 6.4l3 3.2c0 .2.4.3.7.3l.6-.4c.3-.4.3-1 0-1.4L6.3 5z"
              fill="currentColor"></path>
            </svg>
          </span> */}
        </div>
      )}
      <p className={cx("category")}>{tile.___parent.label}</p>
      <h2 className={cx("title")}>{tile.custom_наименование}</h2>
      {tile.custom_картинка_с_порциями_url ? (
        <img
          alt=""
          className={cx("image")}
          src={tile.custom_картинка_с_порциями_url}
        />
      ) : (
        <div className={cx("placeholder")}>
          <img src={placeholderImage} className={cx("placeholderImage")} alt="" />
          <p className={cx("placeholderText")}>
            У нас нет изображения для этого блюда.
            <br />
            <br />
            Все в порядке, просто продолжайте.
          </p>
        </div>
      )}
      <div className={cx("form")}>
        <DietanamnezTileForm
          onSubmit={onSubmit}
          initialValues={initialValues}
          unitLabel={tile.custom_ед_изм.label}
          portions={portions}
          tutorialWasShown={tutorialWasShown}
        />
      </div>
    </article>
  );
};
